import React from 'react';
import { View, Text, StyleSheet, Image } from 'react-native';
import { SafeAreaView, useSafeAreaInsets } from 'react-native-safe-area-context';
import { router, useLocalSearchParams } from 'expo-router';
import { useLanguage } from '@/contexts/LanguageContext';
import PrimaryButton from '@/components/PrimaryButton';
import TertiaryButton from '@/components/TertiaryButton';

export default function SponsorSuccess() {
  const { t } = useLanguage();
  const insets = useSafeAreaInsets();
  const { sponsorName, isReschedule } = useLocalSearchParams<{
    sponsorName: string;
    isReschedule?: string;
  }>();
  const isRescheduled = isReschedule === '1';

  const handleGoToCsat = () => {
    if (router.canDismiss()) {
      router.dismissAll();
    }
    router.replace('/diary');
    setTimeout(() => {
      router.push('/csat');
    }, 100);
  };

  const handleBackToProfile = () => {
    if (router.canDismiss()) {
      router.dismissAll();
    }
    router.replace('/diary');
    setTimeout(() => {
      router.push('/agendamentos');
    }, 100);
  };

  return (
    <SafeAreaView style={styles.container} edges={['top']}>
      <View style={styles.header}>
        <Text style={styles.headerTitle}>
          {isRescheduled
            ? t('sponsors.success.rescheduleHeader')
            : t('sponsors.success.header')}
        </Text>
      </View>

      <View style={styles.content}>
        <View style={styles.centerGroup}>
          <View style={styles.illustrationContainer}>
            <Image
              source={require('../../assets/images/calendar.png')}
              style={styles.calendarImage}
              resizeMode="contain"
            />
          </View>

          <View style={styles.messageContainer}>
            <Text style={styles.title}>
              {isRescheduled
                ? t('sponsors.success.rescheduleTitle')
                : t('sponsors.success.title')}
            </Text>
            <Text style={styles.subtitle}>
              {isRescheduled
                ? t('sponsors.success.rescheduleSubtitlePrefix')
                : t('sponsors.success.subtitlePrefix')}{' '}
              <Text style={styles.sponsorName}>{sponsorName || ''}</Text>
              {' '}
              {isRescheduled
                ? t('sponsors.success.rescheduleSubtitleSuffix')
                : t('sponsors.success.subtitleSuffix')}
            </Text>
          </View>
        </View>
      </View>

      <View style={[styles.bottomSection, { paddingBottom: insets.bottom + 24 }]}>
        <PrimaryButton
          title={t('sponsors.success.buttonCsat')}
          onPress={handleGoToCsat}
        />
        <TertiaryButton
          title={isRescheduled
            ? t('sponsors.success.rescheduleButton')
            : t('sponsors.success.button')}
          onPress={handleBackToProfile}
        />
      </View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F9F8F3',
  },
  header: {
    paddingHorizontal: 24,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#F9F8F3',
    height: 56,
  },
  headerTitle: {
    fontSize: 14,
    color: '#151515',
    fontFamily: 'Inter_700Bold',
    lineHeight: 14,
  },
  content: {
    flex: 1,
    paddingHorizontal: 40,
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerGroup: {
    paddingHorizontal: 24,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 24,
  },
  illustrationContainer: {
    width: 280,
    height: 280,
    justifyContent: 'center',
    alignItems: 'center',
  },
  calendarImage: {
    width: 280,
    height: 280,
  },
  messageContainer: {
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
    color: '#151515',
    textAlign: 'center',
    fontFamily: 'Sentient-Regular',
    lineHeight: 28.8,
  },
  subtitle: {
    fontSize: 14,
    color: '#669AB7',
    textAlign: 'center',
    fontFamily: 'Inter_700Bold',
    lineHeight: 19.6,
    marginTop: 8,
  },
  sponsorName: {
    fontFamily: 'Inter_700Bold',
    color: '#669AB7',
  },
  bottomSection: {
    paddingHorizontal: 24,
    paddingTop: 16,
    paddingBottom: 24,
    backgroundColor: '#F9F8F3',
    gap: 4,
  },
});
